import React from 'react'
import { useTranslation } from 'react-i18next'

interface DescriptionToolbarProps {
  listOn: boolean
  canUndo: boolean
  canRedo: boolean
  onBold: () => void
  onList: () => void
  onRule: () => void
  onUndo: () => void
  onRedo: () => void
}

const toolClass = (active: boolean, enabled: boolean): string => {
  const base = 'h-8 min-w-8 rounded-md px-2 text-sm font-Montserrat text-foregrounds-fg-base'
  if (!enabled) {
    return `${base} opacity-40`
  }
  if (active) {
    return `${base} bg-backgrounds-bg-highlight`
  }
  return `${base} hover:bg-backgrounds-bg-component-hover`
}

const bulletMarkerCss = `
  [data-line-kind='bullet']::before { content: '•'; }
  [data-line-kind='bullet'][data-marker='-']::before { content: '-'; }
`

const keepSelection = (event: React.MouseEvent): void => {
  event.preventDefault()
}

const DescriptionToolbar = ({
  listOn,
  canUndo,
  canRedo,
  onBold,
  onList,
  onRule,
  onUndo,
  onRedo
}: DescriptionToolbarProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div className="flex items-center gap-1 border-b border-borders-border-base px-2 py-1">
      <style>{bulletMarkerCss}</style>
      <button
        type="button"
        className={`${toolClass(false, true)} font-bold`}
        aria-label={t('my_vehicles.promotion_description_bold')}
        title={t('my_vehicles.promotion_description_bold')}
        onMouseDown={keepSelection}
        onClick={onBold}>
        B
      </button>
      <button
        type="button"
        className={toolClass(listOn, true)}
        aria-label={t('my_vehicles.promotion_description_list')}
        title={t('my_vehicles.promotion_description_list')}
        aria-pressed={listOn}
        onMouseDown={keepSelection}
        onClick={onList}>
        •
      </button>
      <button
        type="button"
        className={toolClass(false, true)}
        aria-label={t('my_vehicles.promotion_description_rule')}
        title={t('my_vehicles.promotion_description_rule')}
        onMouseDown={keepSelection}
        onClick={onRule}>
        —
      </button>
      <span className="mx-1 h-4 w-px bg-borders-border-base" />
      <button
        type="button"
        className={toolClass(false, canUndo)}
        aria-label={t('my_vehicles.promotion_description_undo')}
        title={t('my_vehicles.promotion_description_undo')}
        disabled={!canUndo}
        onMouseDown={keepSelection}
        onClick={onUndo}>
        ↩
      </button>
      <button
        type="button"
        className={toolClass(false, canRedo)}
        aria-label={t('my_vehicles.promotion_description_redo')}
        title={t('my_vehicles.promotion_description_redo')}
        disabled={!canRedo}
        onMouseDown={keepSelection}
        onClick={onRedo}>
        ↪
      </button>
    </div>
  )
}

export default DescriptionToolbar
